import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

class AppGuide extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> App Guide </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                      Learn about the features and options available within the "AbilitàXR - The experience app" available in Android Play Store.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Introduction</b>
                      <br></br>
                      Welcome to the app guide! We have developed features, 
                      environments and options in our "AbilitàXR - The experience app" 
                       to experience your creations made using our web platform. You can always 
                      contact us or visit our <a href="/faq"> FAQ </a> page if you have any additional questions. 
                      Please watch tutorial videos on our YouTube channel to know more.                   
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Getting started</b>
                      <br></br>
                      1. App download: Download the app from the Playstore. 
                      Follow the instructions in the menu when the app loads up. 
                      When you enter the VR main menu, securely insert your phone into 
                      your VR headset and put your headset on. 
                      <br></br>
                      2. Access Code: Enter your code in the "Access Code" field of the start menu. 
                      This code is available in your Settings menu in the Web Platform. 
                      <br></br>
                      3. Your Creation: Once you publish your creation for Android using the Web Platform,
                      those scenes will appear in the app like magic. You can experiene the immersive view of 
                      your creation in no time. 
                      <br></br>
                      4. Calibrate phone with headset: This is only required if you have a mobile VR 
                      headset which you cannot manually adjust the focus for. For example, with the 
                      iComputingLabs VR Headset, you can move the lens positions manually so you can skip these steps: 
                      <br></br>
                      a. If you find that your experience is a bit blurry, you can sync your phone 
                      to your headset for a higher quality immersive experience. This allows you to 
                      change the focus through software instead of hardware. 
                      <br></br>
                      b. Download the official 'Google Cardboard' app from Google (Android)
                      <br></br> 
                      c. Open the Google Cardboard app and scan the QR code (take a picture of it). 
                      Your device will automatically calibrate itself for the headset and the VR 
                      experience is optimised for your phone's specifications.

                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    Check out these features in our app:
                    </h6>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
                <Row className = "mt-5">
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col className = "mb-5 pb-5" xs="12" sm="12" lg="8">
                    <Row>
                      <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                      </Col>
                      <Col className ="text-right" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3" > Feature 1 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3"> Feature 2 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
  
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default AppGuide;



// WEBPACK FOOTER //
// ./src/views/Pages/AppGuide/AppGuide.js